import { Card, Stack } from 'braid-design-system';

import { useEffectOnce } from 'src/hooks/useEffectOnce';
import { tracking } from 'src/tracking';

import { ListingUpgradeContactHeader } from './components/ListingUpgradeContactHeader';
import { ListingUpgradeContactItems } from './components/ListingUpgradeContactItems';

interface ListingUpgradeContactProps {
  listingId: string;
  clientId: string;
  contractStartDate: string;
}

export const ListingUpgradeContact = ({
  listingId,
  clientId,
  contractStartDate,
}: ListingUpgradeContactProps) => {
  useEffectOnce(() => {
    tracking.sellerDashboard.upgradeContractRequest.prompt.viewed({
      listingId,
      sbizClientId: clientId,
      contractStartDate,
    });
  });

  return (
    <Card tone="formAccent">
      <Stack space="large">
        <ListingUpgradeContactHeader />

        <ListingUpgradeContactItems
          listingId={listingId}
          clientId={clientId}
          contractStartDate={contractStartDate}
        />
      </Stack>
    </Card>
  );
};
